import React from 'react';

interface DataTableLoadingProps {
  rows?: number;
  columns?: number;
}

export const DataTableLoading: React.FC<DataTableLoadingProps> = ({ rows = 5, columns = 4 }) => {
  return (
    <div className="animate-pulse">
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div
          key={rowIndex}
          className="flex items-center gap-4 p-4 border-b border-gray-100 dark:border-gray-800 last:border-b-0"
        >
          {Array.from({ length: columns }).map((_, colIndex) => (
            <div
              key={colIndex}
              className="h-4 bg-gray-200 dark:bg-gray-700 rounded flex-1"
              style={{
                maxWidth: colIndex === 0 ? '150px' : colIndex === columns - 1 ? '80px' : '200px',
              }}
            />
          ))}
        </div>
      ))}
    </div>
  );
};
